module.exports = __webpack_public_path__ + "media/images/weather/700_night-779049b62cefe1d6518b2d9151e0cbfe.png";